module.exports = __webpack_public_path__ + "img/37.7032d4f2.jpg";